import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import Button from "../../../../modules/commons/Button";
import SimpleTimePicker from "../../../../modules/SimpleTimePicker";
import moment from "moment";
import Api from "../../../../Services/Api";
import { v4 as uuidv4 } from "uuid";
import { shortUuid } from "../../masterSopir/utils";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import {
  fetchDataAsync,
  FormatCurrencyWithoutSymbol,
} from "../../../../Services/Utils";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class TabPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || [],
      dataPart: [],
      editingIndex: null,
      promoAllPart: false,
      satuan: null,
      nilaiDiskon: null,
      dataSatuan: [
        { value: "AMOUNT", label: "Currency" },
        { value: "PERCENTAGE", label: "Percentage" },
      ],
      pagination: {
        totalData: props.data?.length || 0,
        page: 1,
        limit: 5,
      },
      loading: false,
      saveRowAlert: false,
      tableDisabled: false,
      rowErrors: {},
    };
  }

  generateTableColumns = () => {
    const { activityType } = this.props;

    const { data, dataPart, dataSatuan, tableDisabled } = this.state;

    const baseColumns = [
      {
          name: "",
          label: "No",
          options: {
              customBodyRender: (value, tableMeta) => {
                  return <>{tableMeta.rowIndex + 1}</>;
              },
              sort: false,
          },
      },
      {
        name: "kodePart",
        label: "Kode Part",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const saved = data[rowIndex].saved !== false;

            if (saved || activityType === "VIEW") return <>{val}</>;

            const currentPart = dataPart?.find((p) => p.value === val);

            return (
              <>
                <SimpleDDL
                  id="input_text_kode_part"
                  box="search"
                  name="kodePart"
                  readOnly={tableDisabled}
                  isClearable
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={dataPart.map((item) => ({
                    label: `${item.value} - ${item.label}`,
                    value: item.value,
                    partName: item.label,
                    category: item.partCategory,
                  }))}
                  value={
                    val
                      ? {
                          label: `${val} - ${currentPart?.label || ""}`,
                          value: val,
                        }
                      : ""
                  }
                  formatOptionLabel={(option, { context }) =>
                    context === "value" ? option.value : option.label
                  }
                  onChange={(selected) =>
                    this.handleRowValueChange(rowIndex, "kodePart", selected)
                  }
                />
                {this.state.rowErrors?.[rowIndex]?.kodePart && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].kodePart}
                  </div>
                )}
              </>
            );
          },
        },
      },
      {
        name: "partName",
        label: "Nama Part",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let save = data[rowIndex].saved !== false;
            if (save || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleDDL
                    id="input_text_nama_part"
                    box="search"
                    name="partName"
                    readOnly={tableDisabled}
                    isClearable
                    containerclassname="margin-bottom-none width width-250px"
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        position: "relative",
                        fontFamily:
                          "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                      }),
                    }}
                    options={dataPart}
                    value={this.findLabel(data[rowIndex].kodePart, dataPart)}
                    onChange={(event) => {
                      this.handleRowValueChange(rowIndex, "partName", event);
                    }}
                  />
                  {this.state.rowErrors?.[rowIndex]?.partName && (
                    <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                      {this.state.rowErrors[rowIndex].partName}
                    </div>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "partCategory",
        label: "Kategori Part",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let saved = data[rowIndex].saved !== false;
            if (saved || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleInput
                    id="input_text_part_category"
                    name="partCategory"
                    readOnly={true}
                    containerclassname="margin-bottom-none width width-250px"
                    value={val}
                  />
                  {this.state.rowErrors?.[rowIndex]?.kodePart && (
                    <p
                      style={{ color: "red", fontSize: 12, marginTop: 20 }}
                    ></p>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "unit",
        label: "Satuan",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let save = data[rowIndex].saved !== false;

            if (save || activityType === "VIEW") return <>{val}</>;

            const currentUnit = dataSatuan.find((s) => s.value === val);

            return (
              <>
                <SimpleDDL
                  id="input_text_unit"
                  box="search"
                  name="unit"
                  readOnly={tableDisabled}
                  isClearable
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={dataSatuan}
                  value={
                    val ? { label: currentUnit?.label || val, value: val } : ""
                  }
                  onChange={(event) =>
                    this.handleRowValueChange(rowIndex, "unit", event)
                  }
                />
                {this.state.rowErrors?.[rowIndex]?.unit && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].unit}
                  </div>
                )}
              </>
            );
          },
        },
      },
      {
        name: "discountValue",
        label: "Nilai Diskon",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const saved = data[rowIndex].saved !== false;
            const unit = data[rowIndex]?.unit;
            const { prefix, suffix } = this.getPrefixSuffixColumn(unit);

            if (saved || this.props.activityType === "VIEW") {
              return (
                <>
                  {prefix}
                  {FormatCurrencyWithoutSymbol({ number: val })}
                  {suffix}
                </>
              );
            }

            return (
              <>
                <SimpleInput
                  id="input_text_off_price"
                  prefix={prefix}
                  suffix={suffix}
                  name="discountValue"
                  readOnly={tableDisabled}
                  containerclassname="margin-bottom-none width width-250px"
                  box="number"
                  value={
                    unit === "CURRENCY"
                      ? FormatCurrencyWithoutSymbol({ number: val })
                      : val
                  }
                  onValueChange={({ value }) => {
                    const target = { value };
                    this.handleRowValueChange(
                      rowIndex,
                      "discountValue",
                      target
                    );
                  }}
                />
                {this.state.rowErrors?.[rowIndex]?.discountValue && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].discountValue}
                  </div>
                )}
              </>
            );
          },
        },
      },
    ];

    if (activityType !== "VIEW") {
      baseColumns.push({
        name: "action",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => {
            const index = tableMeta.rowIndex;
            const row = this.state.data[index];
            const isEditing = this.state.editingIndex === index;

            return (
              <FlexView vAlignContent="center" style={{ gap: 10 }}>
                {(row.isNew && !row.saved) || isEditing ? (
                  <>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleSaveRow(index)}
                    >
                      <i
                        className="fa fa-save"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleDeleteRow(index)}
                    >
                      <i
                        className="fa fa-times-circle"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleEditRow(index)}
                    >
                      <i
                        className="fa fa-pencil-alt"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleDeleteRow(index)}
                    >
                      <i
                        className="fa fa-times-circle"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                  </>
                )}
              </FlexView>
            );
          },
        },
      });
    }

    return baseColumns;
  };

  async componentDidMount() {
    await this.fetchPart();
  }

  fetchPart = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
        menuName: "Master Promo H23",
        setError: this.props.setError,
        args: { paramFilters: { status: "ACTIVE" }, limit: null, page: null },
      });
      if (response.ok && response.data?.data) {
        const dataPart = response.data.data.map((item) => ({
          label: item.partName,
          value: item.kodePart,
          category: item.partCategory,
        }));

        this.setState({
          dataPart,
        });
      }
    } catch (error) {
      console.error("Gagal fetch cabang by main dealer:", error);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const newData = (this.props.data || []).map((item) => {
        const existing = this.state.data.find((d) => d.id === item.id);
        return {
          ...item,
          saved: existing?.saved ?? true,
          isNew: existing?.isNew ?? false,
        };
      });

      // this.setState({
      //   data: newData,
      //   pagination: {
      //     ...this.state.pagination,
      //     totalData: newData.length,
      //   },
      // });

      this.setState((prevValue) => ({
          ...prevValue,
          data: newData,
          pagination: {
              ...prevValue.pagination,
              totalData: newData.length,
          }
      }));
    }

    if (prevProps.errors !== this.props.errors) {
      this.setState({ rowErrors: this.props.errors });
    }
  }

  getPrefixSuffixColumn = (unit) => {
    if (!unit) return { prefix: "", suffix: "" };

    if (unit === "AMOUNT") {
      return { prefix: "Rp. ", suffix: "" };
    }

    if (unit === "PERCENTAGE") {
      return { prefix: "", suffix: "%" };
    }

    return { prefix: "", suffix: "" };
  };

  updateData = (newData) => {
    if (typeof this.props.onDataChange === "function") {
      this.props.onDataChange("part", newData);
    }

    this.setState({ data: newData });
  };

  findLabel = (value, options) => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value
        .map((value) => options.find((item) => item.value === value))
        .filter((item) => item);
    }
    const label = options.find((item) => item.value === value);
    return label ? label : "";
  };

  handleAddRow = () => {
    const updated = [
      ...this.state.data,
      {
        id: uuidv4(),
        kodePart: null,
        unit: null,
        discountValue: null,
        isNew: true,
        parentPromoId: null,
        promoPartId: null,
        saved: false,
      },
    ];
    this.setState({
      data: updated,
      pagination: { ...this.state.pagination, totalData: updated.length },
    });
    this.updateData(updated);
  };

  handleEditRow = (index) => {
    this.setState((prevState) => {
      const updatedData = prevState.data.map((row, i) => {
        if (i === index) {
          return { ...row, saved: false };
        }
        return row;
      });

      return {
        data: updatedData,
        editingIndex: index,
      };
    });
  };

  handleSaveRow = async (index) => {
    const { data } = this.state;
    const row = data[index];

    let rowErrors = {};

    if (!row.kodePart) {
      rowErrors.kodePart = "Field wajib diisi";
    }
    if (!row.partName) {
      rowErrors.partName = "Field wajib diisi";
    }
    if (!row.unit) {
      rowErrors.unit = "Field wajib diisi";
    }
    if (
      row.discountValue === "" ||
      row.discountValue === 0 ||
      row.discountValue === "0" ||
      row.discountValue === null
    ) {
      rowErrors.discountValue = "Field wajib diisi";
    }

    if (Object.keys(rowErrors).length > 0) {
      this.setState((prevState) => ({
        ...prevState,
        rowErrors: {
          ...prevState.rowErrors,
          [index]: rowErrors,
        },
      }));
      return;
    }

    const isDuplicate = data.some(
      (item, i) => i !== index && item.kodePart === row.kodePart
    );
    if (isDuplicate) {
      this.setState((prevState) => ({
        ...prevState,
        rowErrors: {
          ...prevState.rowErrors,
          [index]: { kodePart: "Kode Part sudah ada dalam list." },
        },
      }));
      return;
    }

    this.setState(
      (prevState) => {
        const updatedData = [...prevState.data];
        updatedData[index] = {
          ...updatedData[index],
          saved: true,
          isNew: false,
        };

        const updatedErrors = { ...prevState.rowErrors };
        delete updatedErrors[index];

        return {
          data: updatedData,
          editingIndex: null,
          rowErrors: updatedErrors,
        };
      },
      () => this.updateData(this.state.data)
    );
  };

  handleDeleteRow = (index) => {
    this.setState(
      (prevState) => {
        const updatedData = prevState.data.filter((_, i) => i !== index);

        return {
          ...prevState,
          data: updatedData,
          pagination: {
            ...prevState.pagination,
            totalData: updatedData.length,
          },
          editingIndex:
            prevState.editingIndex === index ? null : prevState.editingIndex,
        };
      },
      () => {
        this.updateData(this.state.data);
      }
    );
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  handleTriggerLoading = (status = null) => {
    this.setState((prev) => ({
      ...prev,
      loading: status !== null ? status : !prev.loading,
    }));
  };

  getPrefixSuffix = () => {
    const unit = this.props.controls?.promoAllPartUnit?.value;

    if (!unit) return { prefix: "", suffix: "" };
    if (unit.value === "AMOUNT") return { prefix: "Rp. ", suffix: "" };
    if (unit.value === "PERCENTAGE") return { prefix: "", suffix: "%" };

    return { prefix: "", suffix: "" };
  };

  handleRowValueChange = (rowIndex, input, event) => {
    if (!event) {
      this.setState(
        (prevState) => {
          const updatedData = [...prevState.data];
          const updatedErrors = { ...prevState.rowErrors };

          if (updatedErrors[rowIndex] && updatedErrors[rowIndex][input]) {
            delete updatedErrors[rowIndex][input];
            if (Object.keys(updatedErrors[rowIndex]).length === 0) {
              delete updatedErrors[rowIndex];
            }
          }

          let updatedRow = { ...updatedData[rowIndex] };

          if (input === "kodePart" || input === "partName") {
            updatedRow = {
              ...updatedRow,
              kodePart: "",
              partName: "",
              partCategory: "",
            };
          } else {
            updatedRow = { ...updatedRow, [input]: "" };
          }

          updatedData[rowIndex] = updatedRow;

          return { ...prevState, data: updatedData, rowErrors: updatedErrors };
        },
        () => this.updateData(this.state.data)
      );
      return;
    }
    this.setState(
      (prevState) => {
        const updatedData = [...prevState.data];
        const selectedPart = prevState.dataPart.find(
          (p) => p.value === event.value || p.label === event.label
        );

        const updatedErrors = { ...prevState.rowErrors };
        if (updatedErrors[rowIndex] && updatedErrors[rowIndex][input]) {
          delete updatedErrors[rowIndex][input];
          if (Object.keys(updatedErrors[rowIndex]).length === 0) {
            delete updatedErrors[rowIndex];
          }
        }

        let updatedRow = { ...updatedData[rowIndex] };

        switch (input) {
          case "kodePart":
          case "partName":
            updatedRow = {
              ...updatedRow,
              kodePart: selectedPart?.value || event.value,
              partName: selectedPart?.label || event.partName || event.label,
              partCategory: selectedPart?.category || updatedRow.partCategory,
            };
            break;

          default:
            updatedRow = {
              ...updatedRow,
              [input]: event.value,
            };
            break;
        }

        updatedData[rowIndex] = updatedRow;

        return { ...prevState, data: updatedData, rowErrors: updatedErrors };
      },
      () => this.updateData(this.state.data)
    );
  };

  handleSaveAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveRowAlert: !prevState.saveRowAlert,
    }));
  };

  handleValueChange = (name, { value }) => {
    this.props.setValue(name, value);
  };

  handleAllPartChange = () => {
    const { controls, setValue } = this.props;
    const newValue = !controls?.promoAllPart?.value;

    setValue("promoAllPart", newValue);
    this.setState({ tableDisabled: newValue });

    if (!newValue) {
      setValue("promoAllPartUnit", null);
      setValue("promoAllPartValue", 0);

      this.setState((prevState) => ({
        ...prevState,
        rowErrors: {
          ...prevState.rowErrors,
          promoAllPartUnit: undefined,
          promoAllPartValue: undefined,
        },
      }));
    }
  };

  render() {
    const { pagination, data, tableDisabled } = this.state;
    const { prefix, suffix } = this.getPrefixSuffix();
    const { controls, activityType } = this.props;

    return (
      <>
        {activityType !== "VIEW" && (
          <FlexView style={{ margin: "20px 0px" }}>
            <SimpleButton
              secondary={
                tableDisabled || controls?.promoAllPart?.value ? true : false
              }
              style={{ marginLeft: 0 }}
              disabled={tableDisabled || controls?.promoAllPart?.value}
              icon={<i className="fa fa-plus margin-right-10px" />}
              onClick={this.handleAddRow}
            >
              Tambah
            </SimpleButton>
          </FlexView>
        )}

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: 16,
          }}
        >
          <SimpleCheckBox
            id="allPart"
            name="promoAllPart"
            label="All Part"
            styles={{ marginBottom: 4 }}
            checked={controls?.promoAllPart?.value || false}
            onChange={this.handleAllPartChange}
            disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
          />

          <div style={{ display: "flex", marginLeft: 45, marginBottom: 20 }}>
            <p style={{ marginTop: 27 }}>
              Satuan :
              {controls?.promoAllPart?.value && (
                <span style={{ color: "red" }}> *</span>
              )}
            </p>
            <div style={{ marginLeft: 10, marginTop: 13 }}>
              <SimpleDDL
                id="select_options_satuan"
                name="promoAllPartUnit"
                box="search"
                value={controls?.promoAllPartUnit?.value}
                options={this.state.dataSatuan}
                isClearable
                containerclassname="margin-bottom-none width width-250px"
                readOnly={
                  this.props.activityType === ACTIVITY_TYPE.VIEW ||
                  !controls?.promoAllPart?.value
                }
                onChange={(value) => {
                  this.props.setValue("promoAllPartUnit", value);
                  this.props.setValue("promoAllPartValue", "");
                }}
              />
              {this.state.rowErrors?.promoAllPartUnit && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                  {this.state.rowErrors?.promoAllPartUnit}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", marginLeft: 10 }}>
            <p style={{ marginTop: 17 }}>
              Nilai Diskon :
              {controls?.promoAllPart?.value && (
                <span style={{ color: "red" }}> *</span>
              )}
            </p>
            <div style={{ marginBottom: 10 }}>
              <SimpleInput
                id="input_text_off_diskon"
                name="promoAllPartValue"
                style={{ marginLeft: 10 }}
                containerclassname="margin-bottom-none width width-250px"
                readOnly={
                  this.props.activityType === ACTIVITY_TYPE.VIEW ||
                  !controls?.promoAllPart?.value
                }
                box="number"
                prefix={prefix}
                suffix={suffix}
                value={controls?.promoAllPartValue?.value}
                onValueChange={(val) =>
                  this.handleValueChange("promoAllPartValue", val)
                }
              />
              {this.state.rowErrors?.promoAllPartValue && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                  {this.state.rowErrors?.promoAllPartValue}
                </div>
              )}
            </div>
          </div>
        </div>

        <SimpleDataTable
          // key={`${pagination.totalData}-${pagination.page}`}
          key={`${pagination.page}-${pagination.totalData}`}
          data={data}
          columns={this.generateTableColumns()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          isRowDisabled={tableDisabled}
        />

        {this.state.saveRowAlert && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            visible={this.state.saveRowAlert}
            onClickClose={this.handleSaveAlertModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleSaveAlertModalVisibility()}
              />
            }
          />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default TabPart;
